<template>
  <v-card flat>
    <v-card-title class="title-font">
      ORDER BAR AFTER DESIGN <v-spacer />
      <div v-if="showErrors && !selection" class="error--text text-body-2">
        <v-icon color="error" class="mr-2">mdi-close-circle</v-icon>
        <span> Please make a selection </span>
      </div>
    </v-card-title>
    <v-card-subtitle class="pb-0">
      Do you plan to order a Nexus milled bar after this case's .STL is
      uploaded?
    </v-card-subtitle>
    <v-card-text class="py-0">
      <v-radio-group hide-details v-model="selection" class="mt-2">
        <v-radio
          v-for="(option, index) in options"
          :key="index"
          :value="option.value"
          :label="option.text"
        />
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "BarAfterDesign",

  props: ["value"],

  inject: ["form"],

  data() {
    return {
      options: [
        {
          text: "Yes, I will use the provided STL in the Nexus milled bar order.",
          value: "yes"
        },
        {
          text: "No, I will use the provided STL to manufacture in-house.",
          value: "no"
        },
        {
          text: "Unsure",
          value: "unsure"
        }
      ],
      showErrors: false,
      valid: true
    }
  },

  computed: {
    selection: {
      get() {
        return this.value
      },
      set(value) {
        this.showErrors = false
        this.$emit("input", value)
      }
    }
  },

  methods: {
    validate() {
      if (!this.selection) this.showErrors = true
      this.valid = !!this.selection
      return !!this.selection
    }
  },

  created() {
    this.form.register(this)
  }
}
</script>
